export default "__VITE_ASSET__CrWYYnf5__"